import { findFirst } from "../../../utils/arrays";
import { withBlockPayment, ymPushParams } from "../../../utils/ym";
import { EAnalyticsConstant, EStatus } from "../../constants";
export var onPaymentModalSuccessAnalyticsHandler = function onPaymentModalSuccessAnalyticsHandler(sum) {
  ymPushParams(withBlockPayment({
    sbp: {
      success: sum
    }
  }));
};
export var onPaymentModalErrorAnalyticsHandler = function onPaymentModalErrorAnalyticsHandler() {
  var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EAnalyticsConstant.Error;
  ymPushParams(withBlockPayment({
    sbp: {
      error: error
    }
  }));
};
export var onPaymentModalAnalyticsHandler = function onPaymentModalAnalyticsHandler(data) {
  var sum = data.sum,
    step = data.step;
  var isError = step === EStatus.Error;
  var isSuccess = step === EStatus.Success;
  var handler = findFirst([isError && function () {
    return onPaymentModalErrorAnalyticsHandler(data.title);
  }, isSuccess && function () {
    return onPaymentModalSuccessAnalyticsHandler(sum);
  }, function () {
    var _data$title;
    return onPaymentModalErrorAnalyticsHandler((_data$title = data.title) !== null && _data$title !== void 0 ? _data$title : EAnalyticsConstant.TimeoutError);
  }]);
  handler === null || handler === void 0 || handler();
  return data;
};